import * as React from 'react';
import { TrackComponent } from '../components/TrackComponent';
import * as Constants from '../consts/variables';
import { Slider } from './Slider';
import { ITeaser, Teaser } from './Teaser';

interface Props {
    teaserData: ITeaser[];
    headline?: string;
    subHeadline?: string;
    trackingCategory?: string;
}

const wrapperStyle: React.CSSProperties = {
    position: 'relative',
    margin: '10px 0px 0px 0px',
};

const headingWrapperStyle: React.CSSProperties = {
    color: Constants.black,
    fontSize: 14,
    marginBottom: 10,
    textAlign: 'center',
};

const headingStyle: React.CSSProperties = {
    marginBottom: 4,
    marginTop: 17,
    position: 'relative',
};

const headingSpanStyle: React.CSSProperties = {
    fontSize: 24,
    background: Constants.white,
    padding: '0 7px',
    position: 'relative',
};

const strikeTroughStyle: React.CSSProperties = {
    position: 'absolute',
    width: '100%',
    top: 14,
    height: 1,
    background: Constants.black,
};

const teaserWrapperStyle: React.CSSProperties = {
    paddingRight: 10,
    display: 'inline-flex',
    minWidth: '95%',
    scrollSnapAlign: 'start',
};

export function TeaserSlider(props: Props) {
    const slides = props.teaserData.map((item, index) => {
        const TrackableTeaser = TrackComponent(Teaser, {
            category: props.trackingCategory || 'teaser-slider',
            action: `teaser ${index + 1}`,
            label: item.title,
        });
        return (
            <div style={teaserWrapperStyle} key={index} className="teaserSlideItem">
                <TrackableTeaser {...item} />
            </div>
        );
    });

    return (
        <div style={wrapperStyle}>
            {props.headline && (
                <div style={headingWrapperStyle}>
                    <h2 style={headingStyle}>
                        <div style={strikeTroughStyle}></div>
                        <span style={headingSpanStyle}>{props.headline}</span>
                    </h2>
                    <div>{props.subHeadline}</div>
                </div>
            )}
            <Slider>{slides}</Slider>
        </div>
    );
}
